// SET FETCH FAIL
export const setFetchFail = () => {
    type: 'FETCH_FAIL'
}

export const startSetFetchFail = () => {
    return(dispatch, getState) => {
        return dispatch(setFetchFail());
    }
};
  


// WEBPACK FOOTER //
// ./src/actions/error.js